import React, { useState } from 'react';
import { Button, Modal } from 'tt-ui-lib/core';
import { RightIcon } from 'tt-ui-lib/icons';
import styles from './ReportProceed.module.scss';

const ReportProceed = (props) => {
  const { draftId, onProceedDraft, buttonType = 'default' } = props;
  const onClick = () => {
    if (onProceedDraft) onProceedDraft();
    else window.location.replace(`${process.env.REACT_APP_REPORT}/editReport/${draftId}`);
  };

  return (
    <>
      <Button className={styles.mainButton} type={buttonType} onClick={onClick}>
        Proceed
        <RightIcon className={styles.proccedIcon} />
      </Button>
    </>
  );
};

export default ReportProceed;
